import { Box, Chip, Grid, Button, Paper, Typography } from '@mui/material';
import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { FormProvider, RHFDateRangePickerField, RHFSelectField, RHFTextField } from "../../../common/hook-form"
import Loader from "../../../common/Loader"
import { formatCurrency, formatDateForApi, parseDateAndTime } from "../../../helpers/UtilityHelper"
import { useLazyGetPaginatedShipmentsQuery } from "../../../redux/commonRTK"
import ProzoDataGrid from "../../../common/ProzoDataGrid";
import _ from "lodash";
import { apiConstants, postGeneric } from '../../../common/constants';
import { useSnackbar } from 'notistack';
import { getMerchant } from '../../../helpers/ReduxHelpers';
import { ManifestCourierFilter } from '../../../common/hook-form/CourierFilter';
import { LoadingButton } from '@mui/lab';
import { FONT, SIZE } from '../../../styles/foundation/typography';
import { alertStripSx, helpTextSx, helpTextTypeSx, primaryBtnSx, secondaryBtnSx, btnRowSx } from '../../../styles/patterns';
import { ERROR, PRIMARY_BLUE } from '../../../styles/foundation/colors';
import { primaryTextSx, secondaryTextSx, awbTextSx, cellStackSx, getStatusChipSx, getPaymentChipSx } from './cellStyles';
import CopyIcon from '../../../common/CopyIcon';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const excludes = "additionalData,orderDate,shipmentType,dispatchMode,invoiceNumber,channelName,orderType,pickupDetails.pickupTime,pickupDetails.from_phone_number,pickupDetails.from_email,pickupDetails.from_country,pickupDetails.from_address,pickupDetails.gstin,pickupDetails.from_state,courierDetail.prozoId,gstInfo,shipmentDetail,deliveryDetails,returnInfo,deliveryTime,itemList,actualDeliveryTat,proshipDeliveryTat,courierDeliveryTat,actualPickUpTime,lastStatusUpdateTime,edd,epd,lifeCycleComplete,courier,merchantDetail,courierId,version,order_history,orderManifest,invoiceUrl,courierPricingRTO,courierPricing,overriddenCourierAccountCode,isDiscrepancyRaised,discrepancyId,securityKey,sortCode,channelType,createdByUser,skipRule,modifiedByUser,rvp_reason,channel_name,customer_detail,cpErrorList,mongoLabelSignedUrlDetails,overriddenCourierRule,mongoInvoiceSignedUrlDetails,merchant,merchantPricing,courierPricingRTO,modifiedByUser,lastModifiedDate,terminalStatus,merchantPricingRTO,customerDetail";


function PickupsPending() {
    const merchant = getMerchant();
    const merchantId = merchant.id ? merchant.id : ''

    const [reload, setReload] = useState(0)
    const { enqueueSnackbar } = useSnackbar()
    const [page, setPage] = useState(0);
    const [isLoadingP, setIsLoadingP] = useState(false);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [andFilters, setAndFilters] = useState([]);
    const [rowSelectionModel, setRowSelectionModel] = useState([]);
    const [selectedAwbNumbers, setSelectedAwbNumbers] = useState([]);
    const [combinedData, setCombinedData] = useState([]);
    const [getPaginatedShipments, { data, isLoading, isFetching }] = useLazyGetPaginatedShipmentsQuery()

    const defaultFilters = [
        // { field: "is_reverse", operator: "eq", value: true },
        { field: "orderStatus", operator: "in", value: ['ORDER_PLACED', 'PICKUP_PENDING', 'PICKUP_FAILED', 'OUT_FOR_PICKUP', 'AWB_REGISTERED'] },
        { field: "manifestDetails", operator: "exists", value: false },
        { field: "shipmentType", operator: "eq", value: "B2C" },
        { field: "merchant.$id", operator: "eq", value: merchantId }]

    const beardoChannels = [{
        "id": "SHOPIFY",
        "parent": "SHOPIFY"
    },
    {
        "id": "WMS",
        "parent": "WMS"
    },
    {
        "id": "Proship",
        "parent": "Proship"
    },
    ]

    useEffect(() => {
        getPaginatedShipments({
            offset: (page * sizePerPage),
            limit: sizePerPage,
            andfilter: [...defaultFilters, ...andFilters],
            excludes
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, sizePerPage, andFilters, reload])

    useEffect(() => {
        if (data?.data) {
            setCombinedData(prevData => {
                const newData = data.data.filter(newItem =>
                    !prevData.some(prevItem => prevItem.id === newItem.id)
                );
                return [...prevData, ...newData];
            });
        }
    }, [data?.data]);

    useEffect(() => {
        const resultArray = combinedData.filter(obj =>
            rowSelectionModel.includes(obj.id)
        );
        setSelectedAwbNumbers(resultArray)
    }, [JSON.stringify(rowSelectionModel), combinedData]);

    // A manifest is a per-courier handover for one pickup location, so every AWB in
    // a single manifest must share BOTH the same pickup pincode AND the same courier
    // account (e.g. Ekart Small vs Ekart Heavy are different accounts/pickups). Mixing
    // couriers here is what caused manifests to contain other couriers' AWBs.
    const getPickupKey = (row) => row?.pickup_details?.from_pincode || '';
    const getCourierKey = (row) => row?.courierDetail?.key || '';

    const uniquePickups = _.uniq(selectedAwbNumbers.map(getPickupKey));
    const uniqueCouriers = _.uniq(selectedAwbNumbers.map(getCourierKey));
    const isMixedPickup = uniquePickups.length > 1;
    const isMixedCourier = uniqueCouriers.length > 1;
    const canGenerate = selectedAwbNumbers.length > 0 && !isMixedPickup && !isMixedCourier;

    // Stop the user from building an invalid batch: only allow selecting rows that
    // match the pickup location (pincode) AND courier of the already-selected (anchor) shipment.
    const handleRowSelectionChange = (newModel) => {
        if (!newModel || newModel.length <= 1) {
            setRowSelectionModel(newModel);
            return;
        }
        const rowsById = new Map(combinedData.map((r) => [r.id, r]));
        const anchorRow = rowsById.get(newModel[0]);
        if (!anchorRow) {
            setRowSelectionModel(newModel);
            return;
        }
        const anchorPickup = getPickupKey(anchorRow);
        const anchorCourier = getCourierKey(anchorRow);
        const allowed = [];
        let rejectedPickup = 0;
        let rejectedCourier = 0;
        newModel.forEach((id) => {
            const row = rowsById.get(id);
            if (!row) { allowed.push(id); return; }
            if (getPickupKey(row) !== anchorPickup) { rejectedPickup += 1; return; }
            if (getCourierKey(row) !== anchorCourier) { rejectedCourier += 1; return; }
            allowed.push(id);
        });
        if (rejectedPickup > 0) {
            enqueueSnackbar(
                "You can only select shipments from the same pickup location (pincode) in a single manifest.",
                { variant: "warning" }
            );
        }
        if (rejectedCourier > 0) {
            enqueueSnackbar(
                "You can only select shipments of the same courier partner in a single manifest.",
                { variant: "warning" }
            );
        }
        setRowSelectionModel(allowed);
    };

    const methods = useForm({
        defaultValues: {
            courier: null,
            pickup_pincode: '',
            awb: '',
            channel: '',
            fromDate: null,
            toDate: null,

        }
    });

    const {
        handleSubmit,
        reset
    } = methods;

    const applyFilters = (filters) => {
        let appliedFilters = [];
        if (filters.courier) {
            // appliedFilters.push({ "field": "courier.$id", "operator": "eq", "value": 'ObjectId(\'' + filters.courier + '\')' });
            appliedFilters.push({ "field": "courierDetail.key", "operator": "eq", "value": filters.courier });
        }
        if (filters.pickup_pincode) {
            appliedFilters.push({ "field": "pickupDetails.from_pincode", "operator": "eq", "value": filters.pickup_pincode })
        }
        if (filters.fromDate) {
            appliedFilters.push({ "field": "awbRegisteredDate", "operator": "gte", "value": formatDateForApi(filters.fromDate) })
        }
        if (filters.toDate) {
            appliedFilters.push({ "field": "awbRegisteredDate", "operator": "lte", "value": formatDateForApi(filters.toDate) })
        }

        if (filters.awb) {
            appliedFilters.push({ "field": "awbNumber", "operator": "eq", "value": filters.awb })
        }
        if (filters.channel) {
            appliedFilters.push({ "field": "channelName", "operator": "eq", "value": filters.channel })
        }
        setAndFilters(appliedFilters)
    }

    const columns = [
        {
            field: 'actions', headerAlign: "left", hideSortIcons: true, headerName: 'Order Details', flex: 1, minWidth: 140,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={primaryTextSx}>{row.reference}</Typography>
                        {row.shippingLabelId && row.reference !== row.shippingLabelId && (
                            <Typography sx={secondaryTextSx}>{row.shippingLabelId}</Typography>
                        )}
                        <Typography sx={secondaryTextSx}>
                            {row.createdDate ? parseDateAndTime(row.createdDate) : ""}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            field: 'awb', headerAlign: "left", hideSortIcons: true, headerName: 'Courier Partner', flex: 1, minWidth: 150,
            renderCell: (params) => {
                const { row } = params;
                let courierParent = (row.courierDetail?.parent)?.includes('Blended') ? row.actualCourierProviderName : row.courierDetail?.parent;
                const childName = row.courierDetail?.name;
                return (
                    <Box sx={cellStackSx}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}><Typography sx={awbTextSx}>{row?.awb_number}</Typography>{row?.awb_number ? <CopyIcon text={row.awb_number} /> : null}</Box>
                        <Typography sx={primaryTextSx}>{courierParent}</Typography>
                        {childName && childName !== courierParent && (
                            <Typography sx={secondaryTextSx}>{childName}</Typography>
                        )}
                    </Box>
                )
            },
        },
        {
            field: 'pickup', headerAlign: "left", hideSortIcons: true, headerName: 'Pickup Details', flex: 1.2, minWidth: 180,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={primaryTextSx}>{row.pickup_details.from_name}</Typography>
                        <Typography sx={secondaryTextSx}>
                            {row.pickup_details.from_address}, {row.pickup_details.from_city}, {row.pickup_details.from_pincode}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            field: 'paymentDetails', headerAlign: "left", hideSortIcons: true, headerName: 'Payment', flex: 0.8, minWidth: 110,
            renderCell: (params) => {
                const { row } = params;
                const paymentMode = row.payment_mode || '';
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={primaryTextSx}>
                            {row.invoice_value ? formatCurrency(row.invoice_value) : "N/A"}
                        </Typography>
                        {paymentMode && <Chip size="small" variant="outlined" label={paymentMode} sx={getPaymentChipSx(paymentMode)} />}
                    </Box>
                )
            },
        },
        {
            field: 'statusDetails', headerAlign: "left", hideSortIcons: true, headerName: 'Status', flex: 0.8, minWidth: 120,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Chip size="small" variant="outlined" label={row.orderStatus} sx={getStatusChipSx(row.orderStatus)} />
                    </Box>
                )
            },
        },
    ];

    const bulkManifestFunc = () => {
        if (selectedAwbNumbers?.length > 0) {
            setIsLoadingP(true)
            postGeneric(apiConstants.GENERATE_MANIFEST, {
                awb_numbers: selectedAwbNumbers.map(obj => obj.awb_number)
            }).then((res) => {
                if (res.status === 200) {
                    enqueueSnackbar("Manifest Generated Successfully", { variant: "success" });
                    setSelectedAwbNumbers([])
                    setRowSelectionModel([])
                    setReload(reload + 1)
                }
            }).catch((err) => {
                console.log(err)
                let message = err?.response?.data?.message ? err?.response?.data?.message : "Something went wrong while generating manifest "
                enqueueSnackbar(message, { variant: "error" })
            }).finally(() => setIsLoadingP(false))
        } else {
            enqueueSnackbar("Select at least one row to proceed.", { variant: "warning" });
        }
    }

    return (
        <>
            {(isLoading || isFetching) && <Loader />}

            <Grid container spacing={2}>
                <Grid item xs={12} spacing={2}>
                    <Paper sx={{ p: 2, boxShadow: 1, borderRadius: 0 }}>
                        <FormProvider methods={methods} onSubmit={handleSubmit(applyFilters)}>
                            {/* Top-align: the courier field carries a hint line beneath it, so
                                centring would shove the other inputs down out of line with it. */}
                            <Grid container spacing={2} alignItems="flex-start">
                                {merchantId === '65f83d1b9e30dd05590fca9f' && (
                                    <Grid item xs={2}>
                                        <RHFSelectField width="100%" name="channel" label={`Select Channel`} options={beardoChannels.map((val) => ({
                                            value: val.id,
                                            label: val.parent
                                        }))} />
                                        {/* <RHFSelectField width="100%" name="channel" label={`Select Channel`} options={_.orderBy(allChannelName, 'name').map((val) => ({
                                            value: val.id,
                                            label: val.parent
                                        }))} /> */}
                                    </Grid>
                                )}
                                <Grid item xs={3} sx={{ overflow: 'hidden' }}>
                                    <ManifestCourierFilter />
                                </Grid>
                                <Grid item xs={3} >
                                    <RHFTextField name="pickup_pincode" label="Pickup Pincode"  />
                                </Grid>
                                <Grid item xs={3}>
                                    <RHFTextField name="awb" label="AWB Number" color="secondary"  />
                                </Grid>
                                <Grid item xs={3}>
                                    <RHFDateRangePickerField label="Created Date" maxDate={new Date()} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Box sx={btnRowSx}>
                                        <Button type="submit" variant="contained" size="small" sx={primaryBtnSx}>Filter</Button>
                                        <Button variant="outlined" size="small" sx={secondaryBtnSx} onClick={() => reset()}>Reset</Button>
                                        <LoadingButton variant="contained" size="small" sx={primaryBtnSx} loading={isLoadingP} disabled={!canGenerate} onClick={bulkManifestFunc}>Generate Manifest</LoadingButton>
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    {isMixedPickup ? (
                                        <Box sx={alertStripSx(ERROR)}>
                                            <WarningAmberIcon sx={{ fontSize: 16, color: ERROR }} />
                                            <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'] }}>
                                                All selected shipments must belong to the same pickup location. You have selected {uniquePickups.length} different pickup pincodes — generate one manifest per pickup location, or use the Pickup Pincode filter to narrow the list.
                                            </Typography>
                                        </Box>
                                    ) : isMixedCourier ? (
                                        <Box sx={alertStripSx(ERROR)}>
                                            <WarningAmberIcon sx={{ fontSize: 16, color: ERROR }} />
                                            <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'] }}>
                                                All selected shipments must belong to the same courier partner. You have selected {uniqueCouriers.length} different couriers — generate one manifest per courier, or use the Select Courier filter to narrow the list.
                                            </Typography>
                                        </Box>
                                    ) : selectedAwbNumbers.length > 0 ? (
                                        <Box sx={helpTextSx}>
                                            <CheckCircleOutlineIcon sx={{ fontSize: 16, color: PRIMARY_BLUE, mt: 0.2 }} />
                                            <Typography sx={helpTextTypeSx}>
                                                Selected shipments share the same pickup location and courier — ready to generate.
                                            </Typography>
                                        </Box>
                                    ) : (
                                        <Box sx={helpTextSx}>
                                            <InfoOutlinedIcon sx={{ fontSize: 16, color: PRIMARY_BLUE, mt: 0.2 }} />
                                            <Typography sx={helpTextTypeSx}>
                                                Select shipments from a single pickup location and courier. A manifest covers one courier &amp; pickup location at a time.
                                            </Typography>
                                        </Box>
                                    )}
                                </Grid>
                            </Grid>

                        </FormProvider>
                    </Paper>
                </Grid>
                <Grid item xs={12}>
                    <ProzoDataGrid
                        columns={columns}
                        hideFooterPagination={false}
                        autoHeight={true}
                        rows={data?.data || []}
                        checkboxSelection={true}
                        keepNonExistentRowsSelected={true}
                        sizePerPage={sizePerPage}
                        setSizePerPage={setSizePerPage}
                        setPage={setPage}
                        page={page}
                        rowSelectionModel={rowSelectionModel}
                        setRowSelectionModel={handleRowSelectionChange}
                        pagination={true}
                        rowCount={data?.count || 0}
                        filterMode={"server"}
                        getRowId={(row) => row.id} />
                </Grid>
            </Grid>
        </>
    )
}
export default PickupsPending
